module.exports = __webpack_public_path__ + "img/ASC_SORT.42c1649a.svg";